import * as React from 'react';
import axios, { AxiosError } from 'axios';
import { Link } from 'react-router-dom';
import { Address, Order, Pays } from './iMonCompte';
import {
  formatNumTva,
  inputColorWhenError,
  inputColorWhenNoError,
  renderAlert,
  renderFilArianne,
  renderInput,
  renderLabel,
  renderTitleH1,
} from './RenderCommon';
import {getUserId, getRole, sessionExpire} from './MonCompteAction';
import {getHostApi, getRequestConfig, initEvent} from '../../utils';
import { formatNumCommande } from './OrderAction';
import Icons from "./Icons";
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';

interface RenderAddressState {
  address: Address;
  allPays: Pays[];
  paysLivraison: Pays[];
  hiddenFacturation: boolean;
  hiddenFavorite: boolean;
  showAlert: boolean;
  textAlert: string;
  classAlert: string;
  showButton: boolean;
  orderId: string;
  type: string;
  numCommande?: string;
  oldCp?: string;
  allowModif: boolean;
  isinternalUser: boolean;
  roleUserAdmin: boolean;
  prevent: boolean;
  orderSignature: string;
  dropshipping: boolean;
}

class RenderAddress extends React.Component<TranslationProps, RenderAddressState> {
  vatChecker: VATCheckerService;

  constructor(props: TranslationProps) {
    super(props);
    this.state = {
      address: {
        id: props.match.params.id,
        prenom: '',
        nom: '',
        societe: '',
        adresse: '',
        adresse2: '',
        adresse3: '',
        code_postal: '',
        ville: '',
        pays: {
          Libelle: 'FRANCE',
          codePays: 'FR',
          idPays: '1',
          inactif: '0',
          taux_tva: '20.00',
          livraisons_pro_uniquement: '0',
          Europe: true
        },
        pays_id: '1',
        telephone_code_pays: 'FR',
        telephone_fixe: '',
        is_facturation: 0,
        is_livraison: 0,
        telephone_mobile: '',
        numero_tva: '',
        libelle: '',
        is_favorite: 0,
      },
      allPays: [],
      paysLivraison: [],
      hiddenFacturation: false,
      hiddenFavorite: false,
      showAlert: false,
      textAlert: 'Votre adresse a bien été mise à jour',
      classAlert: 'alert-success',
      showButton: true,
      orderId: props.match.params.orderId,
      type: props.match.params.type,
      allowModif: false,
      isinternalUser: false,
      roleUserAdmin: false,
      prevent: false,
      orderSignature: '',
      dropshipping: false
    };
    this.vatChecker = new VATCheckerService();
  }

  componentDidMount() {
    if (this.state.address.id) {
      this._getAddressByCustomer();
    } else if (this.state.orderId) {
      this._getOrder(true);
    }

    getRole().then((role: any) => {
      if (role && role.role_id) {
        if(role.role_id == '34' || role.role_id == '22'  ) {
          this.setState({isinternalUser: true, roleUserAdmin: true});
        } else {
          this.setState({isinternalUser: true});
        }
      }
    });
    this._getAllPays();
    this._getPaysLivraison();
  }

  _createStateAddress = (order: Order) => {
    if (this.state.type === 'livraison') {
      this.setState({
        address: {
          ...this.state.address,
          prenom: order.PrenomLivraison,
          nom: order.NomLivraison,
          societe: order.SocieteLivraison,
          adresse: order.Adresse1Livraison,
          adresse2: order.Adresse2Livraison,
          adresse3: order.Adresse3Livraison,
          code_postal: order.CodePostalLivraison,
          ville: order.VilleLivraison,
          pays: {
            Libelle: order.paysLivraison.Libelle,
            codePays: order.paysLivraison.codePays,
            idPays: order.paysLivraison.idPays,
            inactif: order.paysLivraison.inactif,
            taux_tva: order.paysLivraison.taux_tva,
            livraisons_pro_uniquement: order.paysLivraison.livraisons_pro_uniquement,
            Europe: order.paysLivraison.Europe
          },
          pays_id: order.Pays_idPaysLivraison,
          telephone_fixe: order.TelephoneFixe,
          telephone_mobile: order.TelephonePortable,
          numero_tva: order.numTVAIntraco as string
        },
      });
    } else {
      this.setState({
        address: {
          ...this.state.address,
          prenom: order.Prenom,
          nom: order.Nom,
          societe: order.Societe,
          adresse: order.Adresse1,
          adresse2: order.Adresse2,
          adresse3: order.Adresse3,
          code_postal: order.CodePostal,
          ville: order.Ville,
          pays: {
            Libelle: order.paysFacturation.Libelle,
            codePays: order.paysFacturation.codePays,
            idPays: order.paysFacturation.idPays,
            inactif: order.paysFacturation.inactif,
            taux_tva: order.paysFacturation.taux_tva,
            livraisons_pro_uniquement: order.paysFacturation.livraisons_pro_uniquement,
            Europe: order.paysFacturation.Europe
          },
          pays_id: order.Pays_idPays,
          telephone_fixe: order.TelephoneFixe,
          telephone_mobile: order.TelephonePortable,
          numero_tva: order.numTVAIntraco as string
        },
      });
    }

    this.setState({
      numCommande: order.numCommande,
      oldCp: order.CodePostalLivraison,
      orderSignature: order.Signature,
      dropshipping: order.dropshipping
    });
  }

  _getOrder = (updateState: boolean = false) => {
    document.dispatchEvent(initEvent('dp-loading'));
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}`;

    axios.get(url, getRequestConfig())
      .then((response) => {
      if (response.data.order) {
        if (updateState) {
          this._createStateAddress(response.data.order);
        }
        document.dispatchEvent(initEvent('dp-loaded'));
        const statutLimit = this.state.isinternalUser && this.state.type !== 'facturation' ? '8' : '7';
        if (response.data.order.StatutCommande < statutLimit) {
          this.setState({ allowModif: true });
        } else {
          this.setState({ allowModif: false });
        }
      }
    }).catch((error) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  /**
   * Fonction mettant à jour l'adresse d'un client
   *
   * @param {React.MouseEvent<HTMLButtonElement>} event
   * @private
   */
  _updateAddress = () => {
    document.dispatchEvent(new Event('dp-loading'));
    const url = `${getHostApi()}/customers/${getUserId()}/addresses/${this.state.address.id}`;

    axios.put(url, this.state.address, getRequestConfig()).then((response) => {
      this.setState({
        address: { ...this.state.address, telephone_code_pays: response.data.address.pays.codePays },
        hiddenFacturation: response.data.address.is_facturation == '1',
        hiddenFavorite: response.data.address.is_favorite == '1',
        showAlert: true,
        textAlert: 'Votre adresse a bien été mise à jour !',
        classAlert: 'alert-success',
      });

    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      } else {
        this.setState({
          showAlert: true,
          textAlert: error.response.data.message,
          classAlert: 'alert-danger',
        });
      }
    }).finally(() => {
      document.dispatchEvent(new Event('dp-loaded'));
    });
  }

  _updateOrderAddresses = () => {
    this._getOrder();

    setTimeout(() => {
      if (this.state.allowModif) {
        const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/addresses`;

        axios.post(url,
          { adresse: this.state.address, type: this.state.type }, getRequestConfig())
          .then((response) => {
            if (this.state.type !== 'phones') {
              this.setState({ textAlert: 'Votre adresse a bien été mise à jour !' });
              this._testLabel();
            } else {
              this.setState({ textAlert: 'Vos coordonnées téléphoniques ont bien été mises à jour !' });
            }
            this.setState({
              showAlert: true,
              classAlert: 'alert-success',
            });
          }).catch((error) => {
            if (error.response.status === 401) {
              sessionExpire();
            } else {
              this.setState({
                showAlert: true,
                textAlert: error.response.data.message,
                classAlert: 'alert-danger',
              });
            }
          });
      } else {
        this.setState({
          showAlert: true,
          textAlert: 'Une erreur est survenue',
          classAlert: 'alert-danger',
        });
      }
    }, 1500);
  }

  _testLabel = () => {
    if(!this.state.dropshipping || !this.state.isinternalUser) {
      return;
    }
    document.dispatchEvent(new Event('dp-loading'));
    document.getElementsByClassName('textLoader')[0]?.innerText = "Validation de l'étiquette de transport...";
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/test-label`;

    axios.post(url, { 
      numCmd: this.state.numCommande?.split('-')[2],
      signature: this.state.orderSignature,
      orderId: this.state.orderId
    }, getRequestConfig())
    .then(res => this.setState({ textAlert: res.data.message, classAlert: 'alert-success' }))
    .catch((err) => {
      this.setState({
        showAlert: true,
        textAlert: err.response.data.message,
        classAlert: 'alert-danger',
      });
    })
    .finally(() => {
      document.getElementsByClassName('textLoader')[0]?.innerText = "Chargement...";
      document.dispatchEvent(new Event('dp-loaded'));
    });
  }

  _colorEmptyRequiredInput = () => {
    this._colorRequiredInput();
    if (this.state.address.nom === '') {
      inputColorWhenError('nom');
    }
    if (this.state.address.prenom === '') {
      inputColorWhenError('prenom');
    }
    if (this.state.address.adresse === '') {
      inputColorWhenError('adresse');
    }
    if (this.state.address.code_postal === '') {
      inputColorWhenError('code_postal');
    }
    if (this.state.address.ville === '') {
      inputColorWhenError('ville');
    }
    if (this.state.address.telephone_mobile === '') {
      inputColorWhenError('telephone_mobile');
    }
    if (this.state.address.societe && this.state.address.societe !== '' && this.state.address.numero_tva === '') {
      inputColorWhenError('numero_tva');
    }
  }

  _colorRequiredInput = () => {
    if (this.state.address.nom != '') {
      inputColorWhenNoError('nom');
    }
    if (this.state.address.prenom != '') {
      inputColorWhenNoError('prenom');
    }
    if (this.state.address.adresse != '') {
      inputColorWhenNoError('adresse');
    }
    if (this.state.address.code_postal != '') {
      inputColorWhenNoError('code_postal');
    }
    if (this.state.address.ville != '') {
      inputColorWhenNoError('ville');
    }
    if (this.state.address.telephone_mobile != '') {
      inputColorWhenNoError('telephone_mobile');
    }
    if ((this.state.address.societe !== '' && this.state.address.numero_tva != '')
      || (this.state.address.societe === '')) {
      inputColorWhenNoError('numero_tva');
    }
  }

  _verifModifDepartement = () => {
    if (this.state.oldCp?.substr(0, 2) === '20') {
      if (this.state.address.code_postal.substr(0, 2) !== '20') {
        this.setState({
          showAlert: true,
          textAlert: 'Le code postal saisi doit être Corse',
          classAlert: 'alert-danger',
        });
        inputColorWhenError('code_postal');
      } else {
        this._updateOrderAddresses();
      }
    } else {
      if (this.state.address.code_postal.substr(0, 2) === '20') {
        this.setState({
          showAlert: true,
          textAlert: 'Le code postal saisi ne doit pas être Corse',
          classAlert: 'alert-danger',
        });
        inputColorWhenError('code_postal');
      } else {
        this._updateOrderAddresses();
      }
    }
  }

  _setStateError = (wrongElementId: string) => {
    this.setState({
      showAlert: true,
      textAlert: 'Le code postal saisi est incorrect !',
      classAlert: 'alert-danger',
    });
    inputColorWhenError(wrongElementId);
  }

  _verifCpBelge = () => {
    const regex = new RegExp('^[0-9]{4}$');
    if (regex.test(this.state.address.code_postal)) {
      this.setState({
        address: { ...this.state.address, numero_tva: '' },
      }, () => {
        this._toDoIfCpOk();
      });
    } else {
      this._setStateError('code_postal');
    }
  }

  _toDoIfCpOk = () => {
    if (this.state.address.id) {
      this._updateAddress();
    } else if (this.state.orderId) {
      this._updateOrderAddresses();
    } else {
      this._addAddress();
    }
  }

  _toDoIfCpFranceOk = () => {
    if (this.state.address.id) {
      this._updateAddress();
    } else if (this.state.orderId) {
      this._verifModifDepartement();
    } else {
      this._addAddress();
    }
  }

  _verifCpAnglais = () => {
    const newCp = this.state.address.code_postal.replace(' ', '');
    const regex1 = new RegExp('^[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{2}$');
    const regex2 = new RegExp('^[a-zA-Z]{2}[0-9]{2}[a-zA-Z]{2}$');
    const regex3 = new RegExp('^[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{2}$');
    const regex4 = new RegExp('^[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}$');
    const regex5 = new RegExp('^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{2}$');
    const regex6 = new RegExp('^[a-zA-Z]{2}[0-9]{1}[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{2}$');

    if (regex1.test(newCp) || regex2.test(newCp) || regex3.test(newCp) || regex4.test(newCp) || regex5.test(newCp) ||
      regex6.test(newCp)) {
      this._toDoIfCpOk();
    } else {
      this._setStateError('code_postal');
    }
  }

  /**
   * Fonction permettant de vérifier la validité du code postal
   *
   * @private
   */
  _verifCP = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    inputColorWhenNoError('code_postal');
    if (this.state.address.pays.codePays === 'BE') {
      this._verifCpBelge();
    } else if (this.state.address.pays.codePays === 'GB') {
      this._verifCpAnglais();
    } else if (this.state.address.pays.codePays === 'FR') {
      if (this.state.address.code_postal.length === 5 && Number(this.state.address.code_postal)) {
        this._toDoIfCpFranceOk();
      } else {
        this._setStateError('code_postal');
      }
    } else {
      this._toDoIfCpOk();
    }
  }

  /**
   * Fonction permettant de vérifier la validité des numéros de téléphone saisis
   *
   * @param {React.MouseEvent<HTMLButtonElement>} event
   * @private
   */
  _isPhoneValid = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if ((this.state.address.telephone_mobile != '' && this.state.address.telephone_mobile != null) || 
    (this.state.address.telephone_fixe != '' && this.state.address.telephone_fixe != null)) {
      this._verifPhoneMobile(event);
    } else {
      this.setState({
        showAlert: true,
        textAlert: 'Le numéro de téléphone mobile ou fixe est obligatoire',
        classAlert: 'alert-danger',
      });
      inputColorWhenError('telephone_mobile');
    }
  }

  _onUpdateInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    const name = target.name;
    let value = null;
    let tvaObject = {};

    if (target.type == 'checkbox') {
      value = (target.checked) ? '1' : '0';
    } else {
      value = target.value;
    }

    if(name === 'societe' && !value) {
      tvaObject = { numero_tva: null };
    }

    this.setState({
      address: { ...this.state.address, ...tvaObject, [name]: value },
    });
  }

  _onUpdateInputTva = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const valid = !value || this.vatChecker.validateFormat(this.state.address.pays.codePaysTva || '', value || '');
    if(valid) {
      inputColorWhenNoError('numero_tva');
    } else {
      inputColorWhenError('numero_tva');
    }
    
    this.setState({
      address: { ...this.state.address, [name]: value },
      showAlert: !valid,
      prevent: !valid,
      textAlert: !valid ? 'Le numéro de TVA intracommunautaire saisi est incorrect.' : '',
      classAlert: !valid ? 'alert-danger' : ''
    });
  }

  _onUpdateInputCodePostal = async (target: { name: string, value: string }) => {
    let errorMessage = 'Le format du code postal est invalide.';
    const { name, value } = target;
    let valid = true;

    axios.get(`${getHostApi()}/addresses/zip-code/validate`, { 
      ...getRequestConfig(),
      params: { 
        iso_code: this.state.address.pays.codePays,
        zip_code: value
      }
    }).catch((error: AxiosError) => {
      errorMessage = this.props.textsContent?.[error?.response?.data?.message] ?? errorMessage;
      valid = false;
    })
    .then(() => {
      this.setState({
        showAlert: !valid,
        prevent: !valid,
        textAlert: !valid ? errorMessage : '',
        classAlert: !valid ? 'alert-danger' : ''
      });
    });

    inputColorWhenNoError(name)
    this.setState({
      address: { ...this.state.address, [name]: value },
      showAlert: false,
      prevent: true,
      textAlert: '',
      classAlert: ''
    });
  }

  _handleChangePays = (event: React.ChangeEvent<HTMLSelectElement>) => {
    let pays = null;
    for (const item of this.state.allPays) {
      if (item.idPays == event.target.value) {
        pays = item;
      }
    }

    this.setState({
      address: {
        ...this.state.address,
        telephone_fixe: '',
        telephone_mobile: '',
        pays_id: pays?.idPays as string,
        telephone_code_pays: pays?.codePays as string,
        pays: pays as any,
      },
    }, () => {
      this._onUpdateInputCodePostal({
        name: 'code_postal',
        value: this.state.address.code_postal
      });
    });
  }

  /**
   * Fonction retournant toutes les adresses de l'utilisateur conecté
   *
   * @returns {Order[]}
   * @private
   */
  _getAddressByCustomer() {
    document.dispatchEvent(initEvent('dp-loading'));
    const url = `${getHostApi()}/customers/${getUserId()}/addresses/${this.state.address.id}`;

    axios.get(url, getRequestConfig())
      .then((response) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (response.data.address) {
        this.setState({
          address: response.data.address,
          hiddenFacturation: response.data.address.is_facturation == '1',
          hiddenFavorite: response.data.address.is_favorite == '1',
        });
      }
    }).catch((error) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  /**
   * Fonction retournant tous les pays
   *
   * @private
   */
  _getAllPays() {
    const url = `${getHostApi()}/addresses/pays`;

    axios.get(url, getRequestConfig())
      .then((response) => {
      if (response.data.pays) {
        this.setState({
          allPays: response.data.pays,
        });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  /**
   * Fonction retournant tous les pays de livraison
   *
   * @private
   */
  _getPaysLivraison() {
    const url = `${getHostApi()}/addresses/pays/delivery`;

    axios.get(url, getRequestConfig())
      .then((response) => {
        if (response.data.pays) {
          this.setState({
            paysLivraison: response.data.pays,
          });
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  /**
   * Fonction permettant d'ajouter une adresse dans le carnet d'adresses du client
   *
   * @private
   */
  _addAddress() {
    const address = { ...this.state.address };
    if (address.is_facturation == 0) {
      address.is_livraison = 1;
    }

    const url = `${getHostApi()}/customers/${getUserId()}/addresses`;
    axios.post(url, address, getRequestConfig())
      .then((response) => {
      if (response.data.address) {
        this.setState({
          address: { ...this.state.address, telephone_code_pays: response.data.address.pays.codePays },
          showAlert: true,
          textAlert: 'Votre adresse a bien été créée!',
          classAlert: 'alert-success',
          showButton: false,
        });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      } else {
        this.setState({
          showAlert: true,
          textAlert: error.response.data.message,
          classAlert: 'alert-danger',
        });
      }
    });
  }

  /**
   * Fonction permettant de vérifier tous les champs du formulaire
   *
   * @private
   */
  _verifForm(event: React.MouseEvent<HTMLButtonElement>) {
    this._colorRequiredInput();
    if (this.state.address.nom === '' || this.state.address.prenom === ''
      || this.state.address.adresse === '' || this.state.address.code_postal === '' || this.state.address.ville === ''
      || this.state.address.telephone_code_pays === '' || this.state.address.telephone_mobile === '') {
      this.setState({
        showAlert: true,
        textAlert: 'Veuillez renseigner les champs obligatoires !',
        classAlert: 'alert-danger',
      });
      this._colorEmptyRequiredInput();
    } else {
      if(this.state.address.pays.codePays !== 'FR' && this.state.address.numero_tva !== '') {
        this._verifTVA();
      } else {
        this._verifCP(event);
      }
    }
  }

  /**
   * Fonction permettant de vérifier la validité du numéro de TVA intracommunautaire
   *
   * @private
   */
  _verifTVA() {
    if(!this.state.address.numero_tva) {
      if (this.state.address.id) {
        this._updateAddress();
      } else if (this.state.orderId) {
        this._updateOrderAddresses();
      }
      return;
    }
    document.dispatchEvent(new Event('dp-loading'));
    inputColorWhenNoError('numero_tva');

    const url = `${getHostApi()}/addresses/numero-tva/validate`;
    axios.post(url, {
      numero_tva: this.state.address.numero_tva,
      societe: this.state.address.societe,
      codePays: this.state.address.pays.codePaysTva,
      nom: this.state.address.nom
    }, getRequestConfig()).then((response) => {
      if (response.data.valid === true) {
        if (this.state.address.id) {
          this._updateAddress();
        } else if (this.state.orderId) {
          this._updateOrderAddresses();
        } else {
          this._addAddress();
        }
      } else {
        this.setState({
          showAlert: true,
          textAlert: 'Le numéro de TVA intracommunautaire saisi est incorrect.',
          classAlert: 'alert-danger',
        });
        inputColorWhenError('numero_tva');
      }
    }).catch((error) => {
      this.setState({
        showAlert: true,
        textAlert: error.response.data?.message ?? 'Le numéro de TVA intracommunautaire saisi est incorrect.',
        classAlert: 'alert-danger',
      });
      inputColorWhenError('numero_tva');
    }).finally(() => {
      document.dispatchEvent(new Event('dp-loaded'));
    });
  }

  /**
   * Fonction permettant de vérifier la validité du numéro de téléphone fixe
   *
   * @private
   */
  _verifPhoneFixe(event: React.MouseEvent<HTMLButtonElement>) {
    inputColorWhenNoError('telephone_fixe');

    const url = `${getHostApi()}/addresses/phone-number/validate`;
    axios.post(
      url,
      {
        phone_number: this.state.address.telephone_fixe,
        code_pays: this.state.address.pays.codePays,
      },
      getRequestConfig()).then((response) => {
        if (response.data.phone_number_validate.valid == false) {
          this.setState({
            showAlert: true,
            textAlert: 'Le numéro de téléphone fixe n\'est pas valide',
            classAlert: 'alert-danger',
          });
          inputColorWhenError('telephone_fixe');
        } else if (!this.state.type) {
          this._verifForm(event);
        } else {
          this._updateOrderAddresses();
        }
      }).catch((error) => {
        console.log(error.response.data.message);
      });
  }

  /**
   * Fonction permettant de vérifier la validité du numéro de téléphone mobile
   *
   * @private
   */
  _verifPhoneMobile(event: React.MouseEvent<HTMLButtonElement>) {
    inputColorWhenNoError('telephone_mobile');

    const url = `${getHostApi()}/addresses/phone-number/validate`;
    axios.post(
      url,
      {
        phone_number: this.state.address.telephone_mobile ? this.state.address.telephone_mobile : this.state.address.telephone_fixe,
        code_pays: this.state.address.pays.codePays,
      },
      getRequestConfig()).then((response) => {
        if (response) {
          this.setState({
            address: {
              ...this.state.address,
              telephone_code_pays: response.data.phone_number_validate.pays_phone_number,
            },
          });
          if (response.data.phone_number_validate.valid === false) {
            this.setState({
              showAlert: true,
              textAlert: 'Le numéro de téléphone mobile n\'est pas valide',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('telephone_mobile');
          } else if (this.state.address.telephone_fixe != '' && this.state.address.telephone_fixe != null) {
            this._verifPhoneFixe(event);
          } else if (!this.state.type) {
            this._verifForm(event);
          } else {
            this._updateOrderAddresses();
          }
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  render() {
    const renderDisbledField = (content: string) => {
      return <div className="col-md-6">{content}</div>
    };

    const renderLibelle = () => {
      if (!this.state.orderId) {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Libellé :')}
            {renderInput('text', 'libelle', this.state.address.libelle, this._onUpdateInput)}
          </div>
        );
      }
    };
    const renderIsFavorite = () => {
      if (!this.state.orderId) {
        let typeAdresse = 'Adresse de livraison favorite';
        if (this.state.address.is_livraison == 0 && this.state.address.is_facturation == 1) {
          typeAdresse = 'Adresse de facturation favorite';
        } else if (this.state.address.is_livraison == 1 && this.state.address.is_facturation == 1) {
          typeAdresse = 'Adresse favorite';
        }
        return (
          <div className="d-flex flex-nowrap align-items-center mb-3">
            {renderLabel(typeAdresse)}
            {renderInput('checkbox', 'is_favorite', this.state.address.is_favorite, this._onUpdateInput)}
          </div>
        );
      }
    };

    const renderFirstName = () => {
      if (!this.state.type || this.state.type !== 'phones') {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Prénom* :')}
            {(this.state.orderId && this.state.address.pays.livraisons_pro_uniquement !== '1') || !this.state.orderId || this.state.roleUserAdmin ?
              renderInput('text', 'prenom', this.state.address.prenom, this._onUpdateInput) :
                renderDisbledField(this.state.address.prenom)
            }
          </div>
        );
      }
    };

    const renderLastName = () => {
      if (!this.state.type || this.state.type !== 'phones') {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Nom* :')}
            {(this.state.orderId && this.state.address.pays.livraisons_pro_uniquement !== '1') || !this.state.orderId || this.state.roleUserAdmin ?
              renderInput('text', 'nom', this.state.address.nom, this._onUpdateInput) :
                renderDisbledField(this.state.address.nom)
            }
          </div>
        );
      }
    };

    const renderSociete = () => {
      if (!this.state.type || this.state.type !== 'phones') {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Société :')}
            {(this.state.orderId && this.state.address.pays.livraisons_pro_uniquement !== '1') || !this.state.orderId || this.state.roleUserAdmin ?
              renderInput('text', 'societe', this.state.address.societe, this._onUpdateInput) :
              renderDisbledField(this.state.address.societe)
            }
          </div>
        );
      }
    };

    const renderAdresse1 = () => {
      if (!this.state.type || this.state.type !== 'phones') {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Adresse* :')}
            {(this.state.orderId && this.state.address.pays.livraisons_pro_uniquement !== '1') || !this.state.orderId || this.state.roleUserAdmin ?
              renderInput('text', 'adresse', this.state.address.adresse, this._onUpdateInput) :
              renderDisbledField(this.state.address.adresse)
            }
          </div>
        );
      }
    };

    const renderAdresse2 = () => {
      if (!this.state.type || this.state.type !== 'phones') {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Complément d\'adresse :')}
            {(this.state.orderId && this.state.address.pays.livraisons_pro_uniquement !== '1') || !this.state.orderId || this.state.roleUserAdmin ?
                renderInput('text', 'adresse2', this.state.address.adresse2, this._onUpdateInput) :
                renderDisbledField(this.state.address.adresse2)
            }
          </div>
        );
      }
    };

    /**
     * TODO: A supprimer si jamais affichée
     */
    /*const renderAdresse3 = () => {
     return (
     <div className="d-flex">
     {renderLabel("Adresse :")}
     {renderInput("text", "adresse3", this.state.address.adresse3, this._onUpdateInput)}
     </div>
     );
     };*/

    const renderCP = () => {
      if (!this.state.type || this.state.type !== 'phones') {
        const value = this.state.address.code_postal;
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Code postal* :')}
            {(this.state.orderId && this.state.address.pays.livraisons_pro_uniquement !== '1') || !this.state.orderId || this.state.roleUserAdmin ?
              renderInput('text', 'code_postal', value, (event: React.ChangeEvent<HTMLInputElement>) => this._onUpdateInputCodePostal(event.target)) :
              renderDisbledField(this.state.address.code_postal)
            }
          </div>
        );
      }
    };

    const renderVille = () => {
      if (!this.state.type || this.state.type !== 'phones') {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Ville* :')}
            {(this.state.orderId && this.state.address.pays.livraisons_pro_uniquement !== '1') || !this.state.orderId || this.state.roleUserAdmin ?
              renderInput('text', 'ville', this.state.address.ville, this._onUpdateInput) :
              renderDisbledField(this.state.address.ville)
            }
          </div>
        );
      }
    };

    const renderOptionPays = () => {
      const tabPays = [];
      let allPays = this.state.paysLivraison;
      // On affiche tous les pays pr une adresse de facturation
      if (this.state.address.is_facturation == 1 && this.state.address.is_livraison == 0) {
        allPays = this.state.allPays;
      }

      if (this.state.orderId && this.state.roleUserAdmin) {
        allPays = this.state.allPays;
      }

      for (const pays of allPays) {
        tabPays.push(<option key={pays.idPays} value={pays.idPays}>{pays.Libelle}</option>);
      }

      return tabPays;
    };

    const renderSelectPays = () => {
      if (!this.state.orderId) {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Pays* :')}
            <div className="col-md-6">
              <select className="selectPays rounded border bg-white py-1 px-2 w-100" value={this.state.address.pays_id} onChange={this._handleChangePays}>
                {renderOptionPays()}
              </select>
            </div>
          </div>
        );
      }

      if (this.state.type && this.state.type !== 'phones') {
        return (
          <div className="d-flex align-items-center mb-3">
            {renderLabel('Pays* :')}
            <div className="col-md-6">
              {(!this.state.orderId && this.state.roleUserAdmin && this.state.address.pays.livraisons_pro_uniquement != '1') ? (
                <div className={'d-flex align-items-center'}>
                  <select className="selectPays rounded border bg-white py-1 px-2 w-100" value={this.state.address.pays_id} onChange={this._handleChangePays}>
                    {renderOptionPays()}
                </select>
                  <div className={'flex-grow-1 cursor-help'}
                       title={"Le changement du pays d'une adresse de livraison est interdite. Vous prenez la responsabilité de l'impact de votre action sur le système."}>
                    <Icons icon="warning"  size={16} color="orange" className="ml-2"/>
                  </div>
                </div>
                ) : (
                <>
                  {this.state.address.pays.Libelle}
                </>
              )}
            </div>
          </div>
        );
      }
    };
    const renderIsFacturation = () => {
      if (!this.state.hiddenFacturation && !this.state.orderId && !this.state.address.is_livraison) {
        return (
          <div className="d-flex flex-nowrap align-items-center mb-3">
            {renderLabel('Adresse de facturation')}
            {renderInput('checkbox', 'is_facturation', this.state.address.is_facturation, this._onUpdateInput)}
          </div>
        );
      }
    };

    const renderTelephoneFixe = () => {
      return (
        <div className="d-flex align-items-center mb-3">
          {renderLabel('Téléphone fixe :')}
          {renderInput('text', 'telephone_fixe', this.state.address.telephone_fixe, this._onUpdateInput)}
        </div>
      );
    };

    const renderTelephoneMobile = () => {
      return (
        <div className="d-flex align-items-center mb-3">
          {renderLabel('Téléphone mobile :')}
          {renderInput('text', 'telephone_mobile', this.state.address.telephone_mobile, this._onUpdateInput)}
        </div>
      );
    };

    const renderTVAIntra = () => {
      const isDrom = [22,23,24,26].includes(parseInt(this.state.address?.pays.idPays,10));
      const isUEnotFR = parseInt(this.state.address?.pays.idPays,10) !== 1 && this.state.address?.pays.Europe == true;
      if((!this.state.address?.societe)) {
        return <></>;
      }
      const numTva = formatNumTva(this.state.address?.numero_tva || '', this.state?.address?.pays?.codePaysTva || '');
      if (!this.state.type || this.state.type !== 'phones') {
        if ((this.state.address.pays.codePays !== 'FR' && isUEnotFR) || isDrom) {
          return (
            <div className="d-flex align-items-center mb-3">
              {renderLabel('N°TVA Intracommunautaire* :')}
              {!this.state.orderId ?
                  <div className="d-flex codePaysContainer">
                    <input className="inputCodePays" value={this.state.address.pays.codePaysTva} disabled/>
                    {renderInput('text', 'numero_tva', numTva, this._onUpdateInputTva)}
                  </div>
                  :
                  <div className="col-md-6">
                    {this.state.address.pays.codePays}{numTva}
                  </div>
              }
            </div>
          );
        }
      }
    };

    const renderTelephones = () => {
      if (!this.state.type || this.state.type === 'phones') {
        return (
          <div>
            {renderTelephoneMobile()}
            {renderTelephoneFixe()}
          </div>
        );
      }
    };

    const renderAddress = () => {
      return (
        <div className="mb-4 divFormProfil">
          {renderLibelle()}
          {renderIsFacturation()}
          {renderIsFavorite()}
          {renderFirstName()}
          {renderLastName()}
          {renderSociete()}
          {renderAdresse1()}
          {renderAdresse2()}
          {renderCP()}
          {renderVille()}
          {renderSelectPays()}
          {renderTVAIntra()}
          {renderTelephones()}
        </div>
      );
    };

    const defineTextValidateButton = () => {
      if (this.state.address.id) {
        if (this.state.address.is_facturation == 1 && this.state.address.is_livraison == 0) {
          return 'Mettre à jour mon adresse de facturation';
        }
        if (this.state.address.is_facturation == 0 && this.state.address.is_livraison == 1) {
          return 'Mettre à jour mon adresse de livraison';
        }
        return 'Mettre à jour mon adresse';
      }
      if (this.state.type) {
        if (this.state.type !== 'phones') {
          return 'Modifier mon adresse de ' + this.state.type;
        }
        return 'Mettre à jour mes coordonnées téléphoniques';
      }
      return 'Ajouter mon adresse';
    };

    const renderFormAddress = () => {
      return (
        <div className="w60 formProfil text-center mx-auto border p-3">
          {renderLoaderStyle()}
          <form>
            {renderAddress()}
            {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
            {renderValidateButton()}
          </form>
        </div>
      );
    };

    const renderLoaderStyle = () => {
      return (
          <style>{"\
        .wrapperLoader{\
          background:rgba(255, 255, 255, 0.5);\
        }\
      "}</style>
      );
    }

    const renderValidateButton = (): JSX.Element => {
      let button = (<></>);
      const disabled = this.state.prevent || !((this.state.orderId && this.state.address.pays.livraisons_pro_uniquement !== '1') || !this.state.orderId || this.state.roleUserAdmin)
      const classes = !disabled ? 'bg-blue white' : '';
      if (this.state.showButton) {
        button = (
          <button
            className={`profilButton border-0 py-1 px-3 reset-button buttonPrimary ${classes}`}
            disabled={disabled}
            onClick={this.state.type !== 'phones' ? this._verifCP : this._isPhoneValid}
          >
            {defineTextValidateButton()}
          </button>
        );
      }
      return button;
    };

    const defineTitle = () => {
      if (this.state.address.id) {
        if (this.state.address.is_facturation == 1 && this.state.address.is_livraison == 0) {
          return 'Modifier mon adresse de facturation';
        }

        if (this.state.address.is_facturation == 0 && this.state.address.is_livraison == 1) {
          return 'Modifier mon adresse de livraison';
        }
        return 'Modifier mon adresse';
      }
      if (this.state.type) {
        if (this.state.type !== 'phones') {
          return 'Mettre à jour mon adresse de ' + this.state.type;
        }
        return 'Mettre à jour mes coordonnées téléphoniques';
      }
      if (this.state.address.is_facturation == 1) {
        return 'Ajouter une adresse de facturation';
      }
      return 'Ajouter une adresse de livraison';
    };

    const defineArianne = () => {
      if (this.state.orderId && this.state.numCommande) {
        return 'Commande n°' + formatNumCommande(this.state.numCommande);
      }
      return 'Mon carnet d\'adresses';
    };

    const defineLink = () => {
      if (this.state.orderId) {
        return '/orders/' + this.state.orderId;
      }
      return '/addresses';
    };

    return (
      <div>
        <div>
          {renderTitleH1('carnet', defineTitle())}
        </div>
        {renderFilArianne(<Link className="grey" to={`${defineLink()}`}>{defineArianne()}</Link>, defineTitle())}
        {renderFormAddress()}
      </div>
    );
  }
}

export default WithTranslation(RenderAddress, 'EXCEPTIONS');
